__webpack_require__.p = "/culinaryuniverse/";